import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import '../css/Footer.css';

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <div>
          <span
            style={{
              display: 'inline-block',
              paddingRight: '20px',
            }}
          >
            American Violence © 2018
          </span>
          <Link to={{ pathname: '/cities' }} style={{ marginRight: '10px' }}>
            Cities
          </Link>
          <span> </span>
          <Link to={{ pathname: '/about' }} style={{ marginRight: '10px' }}>
            About
          </Link>
          <Link to={{ pathname: '/news' }}>News</Link>
        </div>
      </div>
    );
  }

  constructor(props) {
    super();
    this.state = {};
  }
  componentDidMount() {
    console.log('footer');
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx